module.exports = __webpack_public_path__ + "media/images/top/magazine-sample01-ae99d058403e7471b4ef3935843901c3.jpg";